// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 65 ? "initial" : chunkId) + "." + {"65":"affd32a2","116":"4d0af7bb","209":"15f57890","268":"33df5675","404":"2415003c","467":"aad03fc6","699":"9ee01ead","727":"210f039a","807":"2d3583ed"}[chunkId] + ".chunk.js";
};